'use strict';



export default class date {
    constructor() {
        
        $('.DOB .day-selector,.DOB .month-selector, .DOB .year-selector ').on('change blur', function () {

            var day = $(this).closest('.DOB').find('.day-selector').val();
            var month = $(this).closest('.DOB').find('.month-selector').val();
            var year = $(this).closest('.DOB').find('.year-selector').val();

            //check they all have values before updating the actual input
            var datemax = updateMaxDate(this, day, month, year);

            UpdateHiddenField(this, day, month, year, datemax);
        });

        function UpdateHiddenField(element, day, month, year, datemax)
        {

            //check they all have values and are valid values before updating the actual input
                if (day && month && year 
                    && isNormalInteger(day)
                    && isNormalInteger(month)
                    && isNormalInteger(year)
                    && parseInt(day) <= parseInt(datemax) 
                    && parseInt(month) <= 12 
                    && parseInt(month) > 0
                    && parseInt(year) > 0) 
                {
                    $(element).closest('.DOB').find('.inner-DOB').val(year + "-" + month + "-" + day);
                }
                else {
                    $(element).closest('.DOB').find('.inner-DOB').val("");
                }
        }

        function updateMaxDate(element, day, month, year)
        {
            var datemax = 31;

            switch (month) {
                case "4":
                case "6":
                case "9":
                case "11":
                    datemax = 30;
                    break;
                case "2":
                    if ((parseInt(year) % 4 == 0) && (parseInt(year) % 100 != 0 || parseInt(year) % 400 == 0))//check if leap year
                    {
                        datemax = 29
                    }
                    else {
                        datemax = 28
                    }
                    break;
            }

            $(element).closest('.DOB').find('.day-selector').attr('max', datemax);

            return datemax;
        }

        function isNormalInteger(str) {
			var n = Math.floor(Number(str));
        	return n >= 0;
        }
    }
}